(function () {
  'use strict';

  var root = document.querySelector('[data-blv-dtf]');
  if (!root) return;

  var cfgNode = root.querySelector('[data-blv-dtf-config]');
  if (!cfgNode) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgNode.textContent);
  } catch (err) {
    console.warn('[blvnks-dtf] bad config', err);
    return;
  }

  var mode = cfg.mode === 'gang' ? 'gang' : 'by_size';
  var minIn = Number(cfg.minIn) || 0.5;
  var maxW = Number(cfg.maxWidth) || 22;
  var maxH = Number(cfg.maxHeight) || 22;
  var defaultWidth = Number(cfg.defaultWidth) || 12;
  var dpi = Number(cfg.dpi) || 300;
  var freeShip = Number(cfg.freeShipping) || 7500;
  var cartTotal = Number(cfg.cartTotal) || 0;
  var variants = Array.isArray(cfg.variants) ? cfg.variants : [];
  var accept = cfg.accept || '.png,.jpg,.jpeg,.webp,.svg,.eps,.pdf,.ai,.heic,.tif,.tiff';
  var maxBytes = Number(cfg.maxBytes) || 100 * 1024 * 1024;

  var fileInput = root.querySelector('[data-blv-dtf-input]');
  var landing = root.querySelector('[data-blv-dtf-landing]');
  var editor = root.querySelector('[data-blv-dtf-editor]');
  var designsEl = root.querySelector('[data-blv-dtf-designs]');
  var summaryEl = root.querySelector('[data-blv-dtf-summary]');
  var lightbox = root.querySelector('[data-blv-dtf-lightbox]');
  var lightboxImg = lightbox && lightbox.querySelector('img');

  var designs = [];
  var uploadCaps = null;
  var submitting = false;
  var uid = 0;

  function nextId(prefix) {
    uid += 1;
    return (prefix || 'd') + uid;
  }

  function round2(n) {
    return Math.round(Number(n) * 100) / 100;
  }

  function clamp(n, lo, hi) {
    return Math.min(hi, Math.max(lo, n));
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    var amount = (Math.max(0, Number(cents) || 0) / 100).toFixed(2);
    var fmt = cfg.moneyFormat || '${{amount}}';
    if (fmt.indexOf('{{amount}}') !== -1) return fmt.replace('{{amount}}', amount);
    if (fmt.indexOf('{{amount_no_decimals}}') !== -1) {
      return fmt.replace('{{amount_no_decimals}}', String(Math.round(cents / 100)));
    }
    return '$' + amount;
  }

  function parseVariantMeta(variant) {
    var label = [variant.title, variant.option1].filter(Boolean).join(' ');
    var gang = label.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    if (gang) {
      return {
        kind: 'gang',
        w: Number(gang[1]),
        h: Number(gang[2]),
        label: Number(gang[1]) + '×' + Number(gang[2])
      };
    }
    var band = label.match(/(\d+)\s*[-–]\s*(\d+)/);
    if (band) {
      return {
        kind: 'band',
        min: Number(band[1]),
        max: Number(band[2]),
        label: band[1] + '–' + band[2] + ' sq in'
      };
    }
    return { kind: 'plain', label: variant.title || 'Default' };
  }

  var parsedVariants = variants.map(function (v) {
    var meta = parseVariantMeta(v);
    return {
      id: Number(v.id),
      title: v.title,
      price: Number(v.price) || 0,
      available: v.available !== false,
      kind: meta.kind,
      w: meta.w,
      h: meta.h,
      min: meta.min,
      max: meta.max,
      label: meta.label
    };
  });

  var gangVariants = parsedVariants
    .filter(function (v) { return v.kind === 'gang'; })
    .sort(function (a, b) { return a.w * a.h - b.w * b.h; });

  var bandVariants = parsedVariants
    .filter(function (v) { return v.kind === 'band'; })
    .sort(function (a, b) { return a.max - b.max; });

  function bandForArea(sqIn) {
    var area = Math.max(1, Math.ceil(sqIn || 0));
    if (!bandVariants.length) return null;
    var match = bandVariants.find(function (v) {
      return area >= v.min && area <= v.max;
    });
    if (match) return match;
    if (area < bandVariants[0].min) return bandVariants[0];
    return bandVariants[bandVariants.length - 1];
  }

  function variantForLine(line) {
    if (mode === 'gang') {
      return gangVariants.find(function (v) { return v.id === line.variantId; })
        || gangVariants[0]
        || null;
    }
    return bandForArea(line.widthIn * line.heightIn);
  }

  function lineCents(line) {
    var variant = variantForLine(line);
    if (!variant) return 0;
    return (variant.price || 0) * (Number(line.qty) || 1);
  }

  function allLines() {
    var out = [];
    designs.forEach(function (design) {
      (design.lines || []).forEach(function (line) {
        out.push({ design: design, line: line });
      });
    });
    return out;
  }

  function builderCents() {
    return allLines().reduce(function (sum, row) {
      return sum + lineCents(row.line);
    }, 0);
  }

  function setupReady() {
    if (mode === 'gang') return gangVariants.length > 0;
    return bandVariants.length > 0;
  }

  function aspectOf(design) {
    if (design.widthPx > 0 && design.heightPx > 0) return design.widthPx / design.heightPx;
    var line = design.lines && design.lines[0];
    if (line && line.heightIn > 0) return line.widthIn / line.heightIn;
    return 1;
  }

  function defaultSizeFromPixels(widthPx, heightPx) {
    var wIn = widthPx > 0 ? widthPx / dpi : defaultWidth;
    var hIn = heightPx > 0 ? heightPx / dpi : defaultWidth;
    if (wIn <= 0) wIn = defaultWidth;
    if (wIn > defaultWidth) {
      var scale = defaultWidth / wIn;
      wIn = defaultWidth;
      hIn = hIn * scale;
    }
    if (hIn > maxH) {
      var scaleH = maxH / hIn;
      hIn = maxH;
      wIn = wIn * scaleH;
    }
    return {
      widthIn: round2(clamp(wIn, minIn, maxW)),
      heightIn: round2(clamp(hIn, minIn, maxH))
    };
  }

  function readImageSize(file) {
    return new Promise(function (resolve) {
      if (!file || !file.type || file.type.indexOf('image/') !== 0) {
        resolve({ width: 0, height: 0 });
        return;
      }
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var size = { width: img.naturalWidth || 0, height: img.naturalHeight || 0 };
        URL.revokeObjectURL(url);
        resolve(size);
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        resolve({ width: 0, height: 0 });
      };
      img.src = url;
    });
  }

  function isAllowed(file) {
    var name = (file && file.name) || '';
    var ext = (/\.([a-z0-9]+)$/i.exec(name) || [])[1];
    if (!ext) return true;
    return accept.toLowerCase().indexOf('.' + ext.toLowerCase()) !== -1;
  }

  function ensureUploadCaps() {
    if (uploadCaps) return Promise.resolve(uploadCaps);
    var proxy = cfg.dtfProxy || '/apps/nod-dtf';
    return fetch(proxy + '/api/config', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('upload config');
        return res.json();
      })
      .then(function (data) {
        uploadCaps = (data && data.caps) || {};
        if (data && data.caps && data.caps.maxBytes) maxBytes = Number(data.caps.maxBytes) || maxBytes;
        return uploadCaps;
      });
  }

  function uploadViaNod(file) {
    var proxy = cfg.dtfProxy || '/apps/nod-dtf';
    var name = file.name || 'artwork.bin';
    var type = file.type || 'application/octet-stream';
    var match = /\.([a-z0-9]{1,10})$/i.exec(name);
    var ext = match ? match[1].toLowerCase() : 'bin';

    return ensureUploadCaps().then(function (caps) {
      if (!caps || !caps.presign) throw new Error('Artwork upload service is unavailable');
      return fetch(proxy + '/api/upload-url', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ext: ext, type: type, size: file.size })
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.error || 'Could not prepare upload');
          return data;
        });
      }).then(function (grant) {
        if (!grant.url || !grant.path) throw new Error('Upload service returned an invalid response');
        return fetch(grant.url, {
          method: 'PUT',
          headers: { 'Content-Type': type },
          body: file
        }).then(function (res) {
          if (!res.ok) throw new Error('Upload failed for ' + name);
          var rawBase = String(caps.rawBase || 'https://dtf-stores.s3.us-east-1.amazonaws.com').replace(/\/$/, '');
          return {
            url: rawBase + '/' + String(grant.path).replace(/^\//, ''),
            path: grant.path
          };
        });
      });
    });
  }

  function uploadViaBlvnks(file) {
    var endpoint = cfg.uploadEndpoint || '/apps/blvnks/dtf';
    var name = file.name || 'artwork.bin';
    var type = file.type || 'application/octet-stream';

    return fetch(endpoint + '/upload-url', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        filename: name,
        mimeType: type,
        size: file.size
      })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || !data.ok) throw new Error(data.message || 'upload-url failed');
        return data;
      });
    }).then(function (grant) {
      var body;
      var headers = {};
      if (grant.parameters && grant.parameters.length) {
        body = new FormData();
        grant.parameters.forEach(function (param) {
          body.append(param.name, param.value);
        });
        body.append('file', file, name);
      } else {
        body = file;
        headers['Content-Type'] = type;
      }
      return fetch(grant.url, {
        method: grant.method || 'POST',
        headers: headers,
        body: body
      }).then(function (res) {
        if (!res.ok) throw new Error('Staged upload failed');
        return fetch(endpoint + '/complete', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            resourceUrl: grant.resourceUrl,
            filename: name,
            mimeType: type,
            kind: 'dtf'
          })
        });
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || !data.ok || !data.url) throw new Error(data.message || 'complete failed');
          return { url: data.url, path: data.id || '' };
        });
      });
    });
  }

  function uploadFile(file) {
    return uploadViaBlvnks(file).catch(function (err) {
      console.warn('[blvnks-dtf] blvnks upload unavailable', err);
      return uploadViaNod(file);
    });
  }

  function newLine(design) {
    if (mode === 'gang') {
      var variant = gangVariants[0] || parsedVariants[0];
      return {
        id: nextId('l'),
        widthIn: variant && variant.w ? variant.w : 13,
        heightIn: variant && variant.h ? variant.h : 19,
        qty: 1,
        variantId: variant ? variant.id : 0
      };
    }
    var size = defaultSizeFromPixels(design.widthPx, design.heightPx);
    return {
      id: nextId('l'),
      widthIn: size.widthIn,
      heightIn: size.heightIn,
      qty: 1,
      variantId: 0
    };
  }

  function setLineWidth(design, line, width) {
    var aspect = aspectOf(design);
    line.widthIn = round2(clamp(width, minIn, maxW));
    line.heightIn = round2(clamp(line.widthIn / (aspect || 1), minIn, maxH));
    if (line.heightIn === maxH && aspect) {
      line.widthIn = round2(clamp(maxH * aspect, minIn, maxW));
    }
  }

  function setLineHeight(design, line, height) {
    var aspect = aspectOf(design);
    line.heightIn = round2(clamp(height, minIn, maxH));
    line.widthIn = round2(clamp(line.heightIn * (aspect || 1), minIn, maxW));
    if (line.widthIn === maxW && aspect) {
      line.heightIn = round2(clamp(maxW / aspect, minIn, maxH));
    }
  }

  function addFiles(fileList) {
    var files = Array.prototype.slice.call(fileList || []).filter(Boolean);
    if (!files.length) return;

    var rejected = false;
    var jobs = files.map(function (file) {
      if (file.size > maxBytes) {
        rejected = true;
        setError('Each file must be under ' + Math.round(maxBytes / (1024 * 1024)) + ' MB.');
        return Promise.resolve();
      }
      if (!isAllowed(file)) {
        rejected = true;
        setError('Use PNG, JPG, WebP, SVG, EPS, PDF, AI, or HEIC.');
        return Promise.resolve();
      }

      var design = {
        id: nextId('d'),
        name: file.name || 'Artwork',
        file: file,
        previewUrl: file.type && file.type.indexOf('image/') === 0 ? URL.createObjectURL(file) : '',
        uploadedUrl: '',
        storagePath: '',
        widthPx: 0,
        heightPx: 0,
        uploading: false,
        error: '',
        lines: []
      };

      designs.push(design);
      render();

      return readImageSize(file).then(function (size) {
        design.widthPx = size.width;
        design.heightPx = size.height;
        design.lines = [newLine(design)];
        render();
      });
    });

    Promise.all(jobs).then(function () {
      if (!rejected) setError('');
    });
  }

  function setError(message) {
    var el = root.querySelector('[data-blv-dtf-error]');
    if (!el) return;
    if (message) {
      el.hidden = false;
      el.textContent = message;
    } else {
      el.hidden = true;
      el.textContent = '';
    }
  }

  function removeDesign(id) {
    designs = designs.filter(function (design) {
      if (design.id !== id) return true;
      if (design.previewUrl) URL.revokeObjectURL(design.previewUrl);
      return false;
    });
    render();
  }

  function removeLine(designId, lineId) {
    var design = designs.find(function (item) { return item.id === designId; });
    if (!design) return;
    design.lines = design.lines.filter(function (line) { return line.id !== lineId; });
    if (!design.lines.length) removeDesign(designId);
    else render();
  }

  function stepper(value, step, precision) {
    var next = round2(Number(value) + step);
    if (precision === 0) return Math.max(1, Math.round(next));
    return next;
  }

  function renderLandingDrop(target, extraClass, title) {
    target.innerHTML =
      '<div class="blv-dtf__drop ' + (extraClass || '') + '" data-blv-dtf-drop tabindex="0" role="button">' +
        '<div class="blv-dtf__drop-icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">' +
            '<path d="M12 16V7M12 7l-3.5 3.5M12 7l3.5 3.5"/>' +
            '<path d="M5 16.5V18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1.5"/>' +
          '</svg>' +
        '</div>' +
        '<p class="blv-dtf__drop-t">' + escapeHtml(title || 'Drag & drop files here') + '</p>' +
        '<p class="blv-dtf__drop-s">PNG, JPG, WebP, SVG, EPS, PDF, AI, HEIC · up to 100 MB</p>' +
        '<span class="blv-dtf__browse">Browse files</span>' +
      '</div>';
  }

  function bindDrop(node) {
    if (!node || node.dataset.bound === 'true') return;
    node.dataset.bound = 'true';

    node.addEventListener('click', function () {
      if (fileInput) fileInput.click();
    });
    node.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (fileInput) fileInput.click();
      }
    });
    node.addEventListener('dragover', function (event) {
      event.preventDefault();
      node.classList.add('is-over');
    });
    node.addEventListener('dragleave', function () {
      node.classList.remove('is-over');
    });
    node.addEventListener('drop', function (event) {
      event.preventDefault();
      node.classList.remove('is-over');
      addFiles(event.dataTransfer && event.dataTransfer.files);
    });
  }

  function renderDesign(design) {
    var rows = design.lines.map(function (line) {
      var variant = variantForLine(line);
      var unit = variant ? variant.price : 0;
      var total = lineCents(line);
      var warning = '';
      if (!variant) warning = '<p class="blv-dtf__error">No matching size band for this artwork.</p>';
      else if (mode === 'by_size' && bandVariants.length && Math.ceil(line.widthIn * line.heightIn) > bandVariants[bandVariants.length - 1].max) {
        warning = '<p class="blv-dtf__error">This size is over the largest band. Use a gang sheet instead.</p>';
      }

      var sizeControls;
      if (mode === 'gang') {
        sizeControls =
          '<div class="blv-dtf__field">' +
            '<label>Sheet size</label>' +
            '<div class="blv-dtf__gang-sizes">' +
              (gangVariants.length ? gangVariants : parsedVariants).map(function (variantOpt) {
                var on = variantOpt.id === (variant && variant.id);
                var label = variantOpt.label || variantOpt.title;
                return '<button type="button" class="blv-dtf__gang-size' + (on ? ' is-on' : '') + '" data-act="gang" data-design="' + design.id + '" data-line="' + line.id + '" data-id="' + variantOpt.id + '">' +
                  escapeHtml(label) +
                '</button>';
              }).join('') +
            '</div>' +
          '</div>';
      } else {
        sizeControls =
          '<div class="blv-dtf__field">' +
            '<label>Width (inches)</label>' +
            '<div class="blv-dtf__stepper">' +
              '<button type="button" data-act="w-dec" data-design="' + design.id + '" data-line="' + line.id + '">−</button>' +
              '<input type="number" min="' + minIn + '" max="' + maxW + '" step="0.01" value="' + line.widthIn.toFixed(2) + '" data-act="w" data-design="' + design.id + '" data-line="' + line.id + '">' +
              '<button type="button" data-act="w-inc" data-design="' + design.id + '" data-line="' + line.id + '">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="blv-dtf__field">' +
            '<label>Height (inches)</label>' +
            '<div class="blv-dtf__stepper">' +
              '<button type="button" data-act="h-dec" data-design="' + design.id + '" data-line="' + line.id + '">−</button>' +
              '<input type="number" min="' + minIn + '" max="' + maxH + '" step="0.01" value="' + line.heightIn.toFixed(2) + '" data-act="h" data-design="' + design.id + '" data-line="' + line.id + '">' +
              '<button type="button" data-act="h-inc" data-design="' + design.id + '" data-line="' + line.id + '">+</button>' +
            '</div>' +
          '</div>';
      }

      return (
        '<div class="blv-dtf__line">' +
          '<div class="blv-dtf__fields">' +
            sizeControls +
            '<div class="blv-dtf__field">' +
              '<label>Qty</label>' +
              '<div class="blv-dtf__stepper">' +
                '<button type="button" data-act="q-dec" data-design="' + design.id + '" data-line="' + line.id + '">−</button>' +
                '<input type="number" min="1" step="1" value="' + line.qty + '" data-act="q" data-design="' + design.id + '" data-line="' + line.id + '">' +
                '<button type="button" data-act="q-inc" data-design="' + design.id + '" data-line="' + line.id + '">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="blv-dtf__field">' +
              '<label>Price</label>' +
              '<div class="blv-dtf__money">' + formatMoney(unit) + ' ea</div>' +
            '</div>' +
            '<div class="blv-dtf__field">' +
              '<label>Total</label>' +
              '<div class="blv-dtf__money">' + formatMoney(total) + '</div>' +
            '</div>' +
          '</div>' +
          warning +
        '</div>'
      );
    }).join('');

    var thumb = design.previewUrl
      ? '<img src="' + escapeHtml(design.previewUrl) + '" alt="">'
      : '<div class="blv-dtf__thumb-ph">' + escapeHtml(design.name) + '</div>';

    var status = design.uploading
      ? '<p class="blv-dtf__drop-s">Uploading…</p>'
      : design.error
        ? '<p class="blv-dtf__error">' + escapeHtml(design.error) + '</p>'
        : '';

    return (
      '<article class="blv-dtf__card blv-dtf__design" data-design-id="' + design.id + '">' +
        '<div class="blv-dtf__design-top">' +
          '<div class="blv-dtf__thumb">' +
            thumb +
            (design.previewUrl ? '<button type="button" class="blv-dtf__zoom" data-act="zoom" data-design="' + design.id + '" aria-label="Preview">⌕</button>' : '') +
          '</div>' +
          '<div>' +
            rows +
            (mode === 'by_size'
              ? '<button type="button" class="blv-dtf__add-size" data-act="add-size" data-design="' + design.id + '">+ Add another size</button>'
              : '') +
            status +
          '</div>' +
          '<button type="button" class="blv-dtf__delete" data-act="delete-design" data-design="' + design.id + '">Delete</button>' +
        '</div>' +
      '</article>'
    );
  }

  function renderSummary() {
    var rows = allLines();
    var subtotal = builderCents();
    var combined = cartTotal + subtotal;
    var remain = Math.max(0, freeShip - combined);
    var pct = freeShip > 0 ? Math.min(100, Math.round((combined / freeShip) * 100)) : 100;
    var countLabel = designs.length === 1 ? '1 design' : designs.length + ' designs';

    var linesHtml = rows.map(function (row) {
      var variant = variantForLine(row.line);
      var sizeLabel = mode === 'gang'
        ? (variant && variant.label) || (row.line.widthIn + '×' + row.line.heightIn)
        : row.line.widthIn.toFixed(2) + ' in × ' + row.line.heightIn.toFixed(2) + ' in';
      var img = row.design.previewUrl
        ? '<img src="' + escapeHtml(row.design.previewUrl) + '" alt="">'
        : '<span class="blv-dtf__sum-ph"></span>';
      return (
        '<div class="blv-dtf__sum-line">' +
          img +
          '<div>' +
            '<strong>' + escapeHtml(cfg.productTitle || 'Transfer') + '</strong>' +
            '<span>Size: ' + escapeHtml(sizeLabel) + '<br>Qty ' + row.line.qty + ' pcs</span>' +
          '</div>' +
          '<div class="blv-dtf__money">' + formatMoney(lineCents(row.line)) + '</div>' +
        '</div>'
      );
    }).join('');

    var ready = setupReady() && rows.length && rows.every(function (row) {
      return variantForLine(row.line) && !row.design.uploading;
    });
    var missingUpload = rows.some(function (row) { return !row.design.uploadedUrl && row.design.error; });

    summaryEl.innerHTML =
      '<div class="blv-dtf__summary-head">' +
        '<h2>Order summary</h2>' +
        '<div class="blv-dtf__summary-count">' + countLabel + '</div>' +
      '</div>' +
      linesHtml +
      '<div class="blv-dtf__ship">' +
        '<p class="blv-dtf__ship-copy">' +
          (remain > 0
            ? 'Add ' + formatMoney(remain) + ' for Free Shipping'
            : 'Free shipping unlocked') +
        '</p>' +
        '<div class="blv-dtf__ship-bar"><span style="width:' + pct + '%"></span></div>' +
      '</div>' +
      '<div class="blv-dtf__totals">' +
        '<div class="blv-dtf__row"><span>Subtotal</span><span>' + formatMoney(subtotal) + '</span></div>' +
        '<div class="blv-dtf__row blv-dtf__row--total"><span>Total</span><span>' + formatMoney(subtotal) + '</span></div>' +
      '</div>' +
      (setupReady()
        ? ''
        : '<p class="blv-dtf__error">' +
          (mode === 'gang'
            ? 'Add 13x19 and 16x21 variants on this product before checkout.'
            : 'Add size-band variants on this product before checkout.') +
          '</p>') +
      '<button type="button" class="blv-dtf__atc" data-blv-dtf-atc' + (ready && !missingUpload ? '' : ' disabled') + '>' +
        (submitting ? 'Adding…' : 'Add to cart · ' + formatMoney(subtotal)) +
      '</button>';
  }

  function render() {
    var editing = designs.length > 0;
    root.classList.toggle('blv-dtf--editing', editing);

    if (!editing) {
      if (landing) landing.hidden = false;
      if (editor) editor.hidden = true;
      return;
    }

    if (landing) landing.hidden = true;
    if (editor) editor.hidden = false;

    designsEl.innerHTML =
      '<p class="blv-dtf__kicker">Your designs</p>' +
      designs.map(renderDesign).join('') +
      '<div class="blv-dtf__more" data-blv-dtf-more></div>';

    var more = designsEl.querySelector('[data-blv-dtf-more]');
    renderLandingDrop(more, 'blv-dtf__drop--more', 'Add another design: browse files');
    bindDrop(more.querySelector('[data-blv-dtf-drop]'));

    renderSummary();
  }

  function findLine(designId, lineId) {
    var design = designs.find(function (item) { return item.id === designId; });
    if (!design) return null;
    var line = design.lines.find(function (item) { return item.id === lineId; });
    return line ? { design: design, line: line } : null;
  }

  root.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-act]');
    if (!btn || !root.contains(btn)) return;

    var act = btn.getAttribute('data-act');
    var designId = btn.getAttribute('data-design');
    var lineId = btn.getAttribute('data-line');
    var found = lineId ? findLine(designId, lineId) : null;

    if (act === 'delete-design') {
      removeDesign(designId);
      return;
    }
    if (act === 'add-size') {
      var design = designs.find(function (item) { return item.id === designId; });
      if (!design) return;
      design.lines.push(newLine(design));
      render();
      return;
    }
    if (act === 'zoom') {
      var zoomDesign = designs.find(function (item) { return item.id === designId; });
      if (!zoomDesign || !zoomDesign.previewUrl || !lightbox) return;
      lightboxImg.src = zoomDesign.previewUrl;
      lightbox.hidden = false;
      return;
    }
    if (act === 'gang' && found) {
      var picked = parsedVariants.find(function (v) { return String(v.id) === btn.getAttribute('data-id'); });
      if (!picked) return;
      found.line.variantId = picked.id;
      found.line.widthIn = picked.w || found.line.widthIn;
      found.line.heightIn = picked.h || found.line.heightIn;
      render();
      return;
    }
    if (!found) return;

    if (act === 'w-inc') setLineWidth(found.design, found.line, found.line.widthIn + 0.25);
    if (act === 'w-dec') setLineWidth(found.design, found.line, found.line.widthIn - 0.25);
    if (act === 'h-inc') setLineHeight(found.design, found.line, found.line.heightIn + 0.25);
    if (act === 'h-dec') setLineHeight(found.design, found.line, found.line.heightIn - 0.25);
    if (act === 'q-inc') found.line.qty = stepper(found.line.qty, 1, 0);
    if (act === 'q-dec') found.line.qty = stepper(found.line.qty, -1, 0);
    if (act === 'w-inc' || act === 'w-dec' || act === 'h-inc' || act === 'h-dec' || act === 'q-inc' || act === 'q-dec') render();
  });

  root.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.getAttribute) return;
    var act = input.getAttribute('data-act');
    if (!act) return;
    var found = findLine(input.getAttribute('data-design'), input.getAttribute('data-line'));
    if (!found) return;
    var value = Number(input.value);
    if (act === 'w') setLineWidth(found.design, found.line, value);
    if (act === 'h') setLineHeight(found.design, found.line, value);
    if (act === 'q') found.line.qty = Math.max(1, Math.round(value || 1));
    render();
  });

  root.addEventListener('click', function (event) {
    var atc = event.target.closest('[data-blv-dtf-atc]');
    if (!atc) return;
    addToCart();
  });

  if (lightbox) {
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target.closest('.blv-dtf__lightbox-x')) {
        lightbox.hidden = true;
        if (lightboxImg) lightboxImg.src = '';
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox && !lightbox.hidden) {
        lightbox.hidden = true;
      }
    });
  }

  function postCartItems(items) {
    return fetch(cfg.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add this transfer to cart.');
        }
        return data;
      });
    });
  }

  function clipProp(value) {
    var text = String(value || '');
    return text.length > 255 ? text.slice(0, 255) : text;
  }

  var GANG_PRICE_TIERS = [
    { min: 1, max: 9, pct: 0 },
    { min: 10, max: 24, pct: 10 },
    { min: 25, max: 49, pct: 15 },
    { min: 50, max: null, pct: 20 }
  ];

  function gangTierFor(quantity) {
    var qty = Math.max(1, Number(quantity) || 1);
    var match = GANG_PRICE_TIERS[0];
    GANG_PRICE_TIERS.forEach(function (tier) {
      if (qty >= tier.min && (tier.max == null || qty <= tier.max)) match = tier;
    });
    return match;
  }

  function gangTierLabel(tier) {
    if (!tier) return '';
    if (tier.max == null) return tier.min + '+';
    return tier.min + '–' + tier.max;
  }

  function gangUnitCents(baseCents, quantity) {
    var tier = gangTierFor(quantity);
    return Math.round((Number(baseCents) || 0) * (100 - tier.pct) / 100);
  }

  function gangDimNote(variant, inches) {
    if (!inches) {
      return 'Print size will be confirmed from this file.';
    }

    var sizeText = inches.w.toFixed(1) + '" × ' + inches.h.toFixed(1) + '" at ' + dpi + ' DPI';
    if (!variant || !variant.w || !variant.h) return 'Artwork size: ' + sizeText;

    var fits = (inches.w <= variant.w + 0.05 && inches.h <= variant.h + 0.05) ||
      (inches.h <= variant.w + 0.05 && inches.w <= variant.h + 0.05);
    var sheet = variant.label || (variant.w + '×' + variant.h);

    return 'Artwork size: ' + sizeText + (fits ? '. Fits the ' + sheet + ' sheet.' : '. Larger than the ' + sheet + ' sheet.');
  }

  function initGangForm() {
    var form = root.querySelector('[data-blv-gang-form]');
    if (!form) return;

    var priceEl = form.querySelector('[data-blv-gang-price]');
    var sizesEl = form.querySelector('[data-blv-gang-sizes]');
    var nameEl = form.querySelector('[data-blv-gang-filename]');
    var dimsEl = form.querySelector('[data-blv-gang-dims]');
    var qtyEl = form.querySelector('[data-blv-gang-qty-value]');
    var tiersEl = form.querySelector('[data-blv-gang-tiers]');
    var atc = form.querySelector('[data-blv-gang-atc]');
    var selectedId = gangVariants.length ? gangVariants[0].id : 0;
    var qty = 1;
    var file = null;
    var fileInches = null;

    function selectedVariant() {
      return gangVariants.find(function (variant) { return variant.id === selectedId; }) || null;
    }

    function paint() {
      var variant = selectedVariant();
      var tier = gangTierFor(qty);
      var unit = variant ? gangUnitCents(variant.price, qty) : 0;
      if (priceEl) {
        priceEl.textContent = variant
          ? formatMoney(unit) + ' / sheet' + (tier.pct ? ' · ' + tier.pct + '% off' : '')
          : '';
      }
      if (sizesEl) {
        sizesEl.innerHTML = (gangVariants.length ? gangVariants : []).map(function (variantOpt) {
          var on = variantOpt.id === selectedId;
          return '<button type="button" class="blv-dtf__gang-option' + (on ? ' is-on' : '') + '" data-id="' + variantOpt.id + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
            '<strong>' + escapeHtml(variantOpt.label || variantOpt.title) + '</strong>' +
            '<span>' + formatMoney(variantOpt.price) + '</span>' +
          '</button>';
        }).join('');
      }
      if (nameEl) nameEl.textContent = file ? file.name : 'Choose a file';
      if (dimsEl) {
        dimsEl.hidden = !file;
        if (!file) dimsEl.textContent = '';
        else if (fileInches === 'pending') dimsEl.textContent = 'Checking artwork size…';
        else dimsEl.textContent = gangDimNote(selectedVariant(), fileInches);
      }
      if (qtyEl) qtyEl.textContent = String(qty);
      if (tiersEl && variant) {
        tiersEl.innerHTML =
          '<p class="blv-dtf__sheet-label">Quantity pricing</p>' +
          '<table>' +
            '<thead><tr><th>Sheets</th><th>Off</th><th>Each</th></tr></thead>' +
            '<tbody>' +
              GANG_PRICE_TIERS.map(function (row) {
                var on = row === tier;
                var each = gangUnitCents(variant.price, row.min);
                return '<tr' + (on ? ' class="is-on"' : '') + '>' +
                  '<td>' + gangTierLabel(row) + '</td>' +
                  '<td>' + (row.pct ? row.pct + '%' : '—') + '</td>' +
                  '<td>' + formatMoney(each) + '</td>' +
                '</tr>';
              }).join('') +
            '</tbody>' +
          '</table>';
      }
      if (atc) {
        var total = variant ? unit * qty : 0;
        atc.disabled = submitting || !variant || !file;
        atc.textContent = submitting
          ? 'Adding…'
          : 'Add to cart · ' + formatMoney(total);
      }
    }

    form.addEventListener('click', function (event) {
      var sizeBtn = event.target.closest('.blv-dtf__gang-option');
      if (sizeBtn && sizesEl && sizesEl.contains(sizeBtn)) {
        selectedId = Number(sizeBtn.getAttribute('data-id'));
        paint();
        return;
      }

      if (event.target.closest('[data-blv-gang-pick]')) {
        if (fileInput) fileInput.click();
        return;
      }

      var step = event.target.closest('[data-blv-gang-qty]');
      if (step) {
        qty = Math.max(1, qty + Number(step.getAttribute('data-blv-gang-qty') || 0));
        paint();
        return;
      }

      if (!event.target.closest('[data-blv-gang-atc]')) return;
      event.preventDefault();

      var variant = selectedVariant();
      if (!variant || !file || submitting) {
        setError(file ? 'Choose a sheet size.' : 'Upload your file.');
        return;
      }
      if (file.size > maxBytes) {
        setError('Each file must be under ' + Math.round(maxBytes / (1024 * 1024)) + ' MB.');
        return;
      }
      if (!isAllowed(file)) {
        setError('Use PNG, JPG, WebP, SVG, EPS, PDF, AI, or HEIC.');
        return;
      }

      submitting = true;
      setError('');
      paint();

      uploadFile(file).then(function (stored) {
        var sizeLabel = variant.label || (variant.w + '×' + variant.h);
        var props = {
          Artwork: clipProp(file.name),
          Size: clipProp(sizeLabel),
          Width: Number(variant.w || 0).toFixed(2) + ' in',
          Height: Number(variant.h || 0).toFixed(2) + ' in',
          '_File 1 name': clipProp(file.name),
          '_Transfer type': 'gang',
          '_Line ID': 'gang-sheet'
        };
        if (stored.url) {
          props['_Preview'] = clipProp(stored.url);
          props['_File 1'] = clipProp(stored.url);
        }
        if (stored.path && String(stored.path).indexOf('gid://shopify/') === 0) {
          props['_File ID'] = clipProp(stored.path);
        }
        return postCartItems([{
          id: variant.id,
          quantity: qty,
          properties: props
        }]);
      }).then(function () {
        window.location.href = cfg.cartUrl || '/cart';
      }).catch(function (err) {
        submitting = false;
        paint();
        setError(err.message || 'Unable to add this sheet to cart.');
      });
    });

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var picked = fileInput.files && fileInput.files[0];
        fileInput.value = '';
        if (!picked) return;
        file = picked;
        fileInches = 'pending';
        setError('');
        paint();
        readImageSize(picked).then(function (size) {
          if (file !== picked) return;
          if (size.width > 0 && size.height > 0) {
            fileInches = {
              w: round2(size.width / dpi),
              h: round2(size.height / dpi)
            };
          } else {
            fileInches = null;
          }
          paint();
        });
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    paint();
  }

  if (mode === 'gang') {
    initGangForm();
    return;
  }

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      addFiles(fileInput.files);
      fileInput.value = '';
    });
  }

  var landingDrop = root.querySelector('[data-blv-dtf-drop]');
  bindDrop(landingDrop);

  function addToCart() {
    if (submitting) return;
    var rows = allLines();
    if (!rows.length) {
      setError('Add artwork first.');
      return;
    }

    var blocked = rows.find(function (row) {
      return row.design.uploading || !variantForLine(row.line);
    });
    if (blocked) {
      setError(blocked.design.uploading ? 'Wait for uploads to finish.' : 'This size has no matching product variant.');
      return;
    }

    submitting = true;
    renderSummary();
    setError('');

    var uploads = Promise.all(rows.map(function (row) {
      if (row.design.uploadedUrl) return Promise.resolve(row.design);
      return uploadFile(row.design.file).then(function (stored) {
        row.design.uploadedUrl = stored.url;
        row.design.storagePath = stored.path;
        row.design.error = '';
        return row.design;
      });
    }));

    uploads.then(function () {
      var items = rows.map(function (row) {
        var variant = variantForLine(row.line);
        var sizeLabel = mode === 'gang'
          ? (variant.label || (row.line.widthIn + '×' + row.line.heightIn))
          : row.line.widthIn.toFixed(2) + ' × ' + row.line.heightIn.toFixed(2) + ' in';
        function clip(value) {
          var text = String(value || '');
          return text.length > 255 ? text.slice(0, 255) : text;
        }

        var preview = row.design.uploadedUrl || '';
        var props = {
          Artwork: clip(row.design.name),
          Size: clip(sizeLabel),
          Width: row.line.widthIn.toFixed(2) + ' in',
          Height: row.line.heightIn.toFixed(2) + ' in',
          '_File 1 name': clip(row.design.name),
          '_Transfer type': mode === 'gang' ? 'gang' : 'by-size',
          '_Line ID': row.line.id
        };
        if (preview) {
          props['_Preview'] = clip(preview);
          props['_File 1'] = clip(preview);
        }
        if (row.design.storagePath && String(row.design.storagePath).indexOf('gid://shopify/') === 0) {
          props['_File ID'] = clip(row.design.storagePath);
        }

        return {
          id: variant.id,
          quantity: row.line.qty,
          properties: props
        };
      });

      return postCartItems(items);
    }).then(function () {
      window.location.href = cfg.cartUrl || '/cart';
    }).catch(function (err) {
      submitting = false;
      renderSummary();
      setError(err.message || 'Unable to add this transfer to cart.');
    });
  }
})();
